<template>
	<PrecoaModal v-model:open="open">
		<template #default>
			<div
				class="mb-2 flex w-full flex-col items-center gap-4 text-center font-bold"
			>
				<ExclamationTriangleIcon class="size-12 text-red-400!" />
				{{
					t('encryption.restart.heading', {
						firstName: plan.firstName,
						lastName: plan.lastName,
					})
				}}
			</div>
			<div class="flex w-full flex-col items-center justify-around gap-6">
				<p
					class="mt-4 px-8 text-center font-sans text-sm leading-tight font-normal text-slate-500!"
				>
					{{ t('encryption.restart.body') }}
				</p>
				<p
					class="cursor-pointer text-center font-semibold text-red-500! underline"
					@click="restartPIIAndEncryptionForPlan"
				>
					{{ t('encryption.restart.restartButton') }}
				</p>
				<button
					type="button"
					@click="open = false"
					class="bg-accent-400! text-accent-700! w-full rounded-lg px-16 py-2 font-bold"
				>
					{{ t('encryption.restart.cancelButton') }}
				</button>
			</div>
		</template>
	</PrecoaModal>
</template>

<script setup lang="ts">
import type Plan from '@/classes/Plan'
import PrecoaModal from '@/components/common/PrecoaModal.vue'
import { usePresentationLocale } from '@/i18n'
import { useConfirmIdentity } from '@/mixins/confirmIdentity'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/solid'
import { type PropType } from 'vue'

const { resetPlanHolderEncryptionForPlan } = useConfirmIdentity()
const { t } = usePresentationLocale()

const props = defineProps({
	plan: {
		type: Object as PropType<Plan>,
		required: true,
	},
})

const open = defineModel<boolean>()

async function restartPIIAndEncryptionForPlan() {
	await resetPlanHolderEncryptionForPlan(props.plan.id)
}
</script>
